import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {configAutoLinker_template} from "../components/templates/configAutoLinker_template";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;
declare var page: any;

export class config_auto_linker extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected configAutoLinker: configAutoLinker_template;
    protected validationsList: validationsList_template;
    protected pagination: pagination_template;
    //protected _isLeavePageWarningNeeded: boolean = true;

    protected getModuleName(){
        return "config_auto_linker";
    }

    buildContent() : Array<Element>{

        this.configAutoLinker = new configAutoLinker_template( "list", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("AutoLinker Configuration");

        return [ this.configAutoLinker.build()];
    }

    public fillPage() : void{

        this.getConfigSettings();
    }

    // fill the whole page
    protected getConfigSettings(){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/auto-linker/get/";
        let usrReq_params: Array<Array<string>> = [];

        this.loadingIn(this.configAutoLinker.builtTemplate)

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetConfigSettingsReturn;
        this.XHRHdl.execute();
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    // fill just the list section..
    // @TODO this part..
    protected filterList(){

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.configAutoLinker.builtTemplate.children.namedItem("rules-container").children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/config/auto-linker/get/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.configAutoLinker.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        // @TODO: replace this with something that just updates the list section..
        this.XHRHdl.onReadyStateFunction = this.onGetConfigSettingsReturn;
        this.XHRHdl.execute();
    }

    protected onGetConfigSettingsReturn(req,obj){

        return function(){
            obj.manageResponse(req, obj, function() {
                let responseParsed = JSON.parse(req.request.response);
                let domainRules = [];

                // @TODO everything else so far
                if (responseParsed.generalConfig !== null) {
                    obj.configAutoLinker.setAutoLinkerConfig(responseParsed.generalConfig);
                }

                if (responseParsed.domains && responseParsed.domains.length > 0) {
                    domainRules = responseParsed.domains;
                }
                obj.configAutoLinker.setAutoLinkerDomainRules(domainRules);

                // build the partner options
                let partnerList = [];
                if (responseParsed.partners && responseParsed.partners.length > 0) {
                    for (let partner of responseParsed.partners) {
                        partnerList.push({id: partner.id, name: partner.name});
                    }
                }
                obj.configAutoLinker.affiliateNetworkFilter.setItems(partnerList);

                let execTime = Math.round((new Date().getTime() - obj.XHRHdl.requestStartTime)/1000*100)/100;
                obj.configAutoLinker.setResultInfo(responseParsed.paginatedResults.totalCount, responseParsed.paginatedResults.totalPage,execTime );

                // update the paginator
                obj.viewModel.list.pagination.itemCount(responseParsed.paginatedResults.totalCount);

                // remove spinner..
                obj.loadingOut(obj.configAutoLinker.builtTemplate);
                obj.loadingOut(obj.configAutoLinker.builtTemplate.children.namedItem("rules-container").children.namedItem("list-results"));
            })
        }
    }

    protected save(section){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        this.loadingIn(this.configAutoLinker.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + '/config/auto-linker/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);
        formReq_params.push(["section", section]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    let idBrand = obj.getVnAppZone().getApp().params.idBrand;
                    page.redirect("/brand/"+idBrand+"/config/auto-linker/");

                    obj.loadingOut(obj.configAutoLinker.builtTemplate);
                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "AutoLinker Configuration saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }

                });
            }
        });
        XHRHdl.execute();
    }


    // @TODO: remove?
    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        //let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect('/brand/' + this.getVnAppZone().app.params.idBrand + '/articles/');
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected listReorder(){

        this.filterList();
    }

    protected filterDropdownOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

}



// WEBPACK FOOTER //
// ./js/modules/config_auto_linker.ts